import { useNavigate } from 'react-router-dom';

import {
  openErrorNotification,
  openSuccessNotification,
  isErrorWithMessage,
} from 'shared/lib';
import { HUB_ROUTES } from 'shared/consts/routes/hub';

import { HubFormData, HubForm, useAddHubMutation } from 'entities/hub';

import { ADD_SUCCESS, ADD_ERROR } from '../consts';

const initialValues: HubFormData = {
  id: '',
  name: '',
  description: '',
  address: '',
};

export function AddHub() {
  const [trigger, { isLoading }] = useAddHubMutation();

  const navigate = useNavigate();

  const handleSubmit = async (values: HubFormData) => {
    const { id, ...rest } = values;

    try {
      const res = await trigger(rest).unwrap();

      // костыль
      if (res.statusCode !== 0) {
        openErrorNotification(res.statusDescription);

        return;
      }
      //

      openSuccessNotification(ADD_SUCCESS);

      navigate(`${HUB_ROUTES.HUBS}/${res.hub.id}`);
    } catch (err) {
      const hasErrorMessage = isErrorWithMessage(err);

      const errorText = hasErrorMessage
        ? err.data.statusDescription
        : ADD_ERROR;

      openErrorNotification(errorText);
    }
  };

  return (
    <HubForm
      handleSubmit={handleSubmit}
      initialValues={initialValues}
      loading={isLoading}
      title="Добавление нового зарядного хаба"
    />
  );
}
